import { apiGet, apiPost, apiPatch, apiDelete } from '@/app/api/core/http';
import { CAT_COMPONENT_PACKAGES, CAT_COMPONENT_CATEGORIES } from 'App/utils/Collections';
import { COMPONENTS_PATHS } from './paths';

export const componentsApiAdapter = {
  getComponents: (params, cat, headers) => {
    const { clearParams, ...rest } = params;
    let preparedParams = {
      params: rest,
      clearParams,
      is_protected: true,
    };
    if (headers) {
      preparedParams.headers = headers.headers;
    }
    return apiGet(COMPONENTS_PATHS.components + COMPONENTS_PATHS.suffix, preparedParams);
  },
  getComponentDetails: (id, headers) => {
    if (headers) {
      return apiGet(`${COMPONENTS_PATHS.components}/${id}`, {
        headers: headers,
        is_protected: true,
      });
    } else {
      return apiGet(`${COMPONENTS_PATHS.components}/${id}`, { is_protected: true });
    }
  },
  getComponentsStats: () => apiGet(COMPONENTS_PATHS.stats),
  createComponent: (data) => apiPost(COMPONENTS_PATHS.components, { data, is_protected: true }),
  updateComponent: (id, data) => apiPatch(`${COMPONENTS_PATHS.components}/${id}`, { data, is_protected: true }),
  deleteComponent: (id) => apiDelete(`${COMPONENTS_PATHS.components}/${id}`, { is_protected: true }),

  [CAT_COMPONENT_PACKAGES]: {
    getList: (params) =>
      apiGet(COMPONENTS_PATHS.packages + COMPONENTS_PATHS.suffix, {
        params,
        is_protected: true,
      }),
  },

  [CAT_COMPONENT_CATEGORIES]: {
    getList: (params) =>
      apiGet(COMPONENTS_PATHS.categories + COMPONENTS_PATHS.suffix, {
        params,
        is_protected: true,
      }),
  },
};
